'use strict';

angular.module('shiftTraderApp')
    .controller('DayOffLimitsCtrl', function($scope, TimeService, $state, $stateParams, SAErrorHandler,
                                             $uibModal, Session, DayOffLimits, DayOffLimitStore, $q, UserPermissionsService,
                                             me, org, currentAndFutureLimits, $confirm) {
    var vm = this;

    vm.me = me;
    vm.org = org;
    vm.dayOffLimits = currentAndFutureLimits;

    vm.allDepartments = _.map(vm.org.departments, function(dept) {
      dept._selected = true;
      return dept;
    });

    vm.nowDate = TimeService.getNowInStoreTime();
    vm.currentDate = TimeService.getBeginningOfDayFromDate(vm.nowDate);
    vm.workDayStartHour = Session.getWorkDayStartHour();

    vm.state = {
      isInEditMode: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'day_off_limits.create',
      'day_off_limits.update'
    ];

    function processRawPermissions() {
      var rawPerms = vm.state.rawPermissions;

      vm.state.derivedPermissions = {
        canCreateLimits: rawPerms['day_off_limits.create'],
        canUpdateLimits: rawPerms['day_off_limits.update']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, vm.org.id)
      .then(function(dikt) {
        vm.state.rawPermissions = dikt;

        processRawPermissions();
      });

    vm.toggleMode = function() {
      if (vm.state.isInEditMode) {
        setupWeekToModify();
      }

      vm.state.isInEditMode = !vm.state.isInEditMode;
    };

    var firstWeek = TimeService.getWeekTwixFromMoment(vm.currentDate);

    var startOfWeekDay = Session.getStartOfWeekDay();

    var dayIndexes = [];
    var currIndex = startOfWeekDay;

    _.each([0,1,2,3,4,5,6], function() {
      dayIndexes.push(currIndex);

      if (currIndex === 6) {
        currIndex = 0;
      } else {
        currIndex += 1;
      }
    });

    var notToBeBefore = moment(vm.currentDate).add(1, 'days').hour(0);

    function initDayOffLimitDerivations() {
      vm.exceptionLimits = _.where(vm.dayOffLimits, function(dol) {
        return dol.$isException();
      });

      vm.dowLimits = _.where(vm.dayOffLimits, function(dol) {
        return !dol.$isException();
      });
    }

    function setupWeekToModify() {
      //console.log('setupWeekToModify');
      vm.weekToModify = _.map(dayIndexes, function(dayIndex, idx) {
        var dt = moment(firstWeek.start).add(idx, 'days').hour(0);

        if (dt.isBefore(notToBeBefore)) {
          dt.add(1, 'weeks');
        }

        //console.log(idx, dayIndex, dt.format());

        var matchingLimit = _.find(vm.dowLimits, function(limit) {
          return limit.day_of_week === dayIndex && limit.$isInEffect(dt);
        });

        return {
          dayIndex: dayIndex,
          idx: idx,
          dt: dt,
          dtTwix: moment(dt).twix(moment(dt).add(1, 'days')),
          dayOffLimit: matchingLimit,
          modelLimit: matchingLimit ? matchingLimit.limit : ''
        };
      });

      //console.log(vm.weekToModify);
    }

    function reloadDayOffLimits() {
      var startDate = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());
      var endDate = TimeService.getBeginningOfDayFromDate(moment(startDate).add(370, 'days'));

      DayOffLimitStore.getLimitsBetween(startDate, endDate, true)
        .then(function(dayOffLimits) {
          vm.dayOffLimits = dayOffLimits;

          initDayOffLimitDerivations();
          setupWeekToModify();
        }, function() {

        });
    }





    vm.hasUnsavedLimits = function() {
      return vm.weekToModify && _.any(vm.weekToModify, function(day) {
          return day.dayOffLimit ? (day.modelLimit !== day.dayOffLimit.limit) : day.modelLimit !== '';
      });
    };

    vm.saveNewLimits = function() {
      // see which limits need to be updated first!

      var daysToUpdate = _.where(vm.weekToModify, function(day) {
        return day.dayOffLimit ? (day.modelLimit !== day.dayOffLimit.limit) : day.modelLimit !== '';
      });

      var createPromises = _.map(daysToUpdate, function(day) {
        return DayOffLimits.create({
          organization_id: vm.org.id,
          limit: day.modelLimit,
          effective_date: day.dt.format('YYYY-MM-DD'),
          day_of_week: day.dayIndex
        });
      });

      $q.all(createPromises).then(function(newLimits) {
        //console.log(newLimits);
        DayOffLimitStore.addOrReplaceRecords(newLimits);
        reloadDayOffLimits();
        vm.toggleMode();
      }, function() {

      });

    };



    //vm.weeks = _.map([0,1,2,3,4,5], function(x) {
    //  return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
    //});
    //
    ////clip it down to the last week that has a day in the current month
    //_.each([5,4], function(x) {
    //  if (!vm.weeks[1].start.isSame(vm.weeks[x].start, 'month')) {
    //    vm.weeks.splice(x,1);
    //  }
    //});
    //
    //$scope.datesByWeek = _.map(vm.weeks, function(week) {
    //  return _.map(_.range(7), function(dayNum) {
    //    return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
    //  });
    //});



    vm.decrementLimit = function(day) {
      if (day.modelLimit === '' || _.isNaN(day.modelLimit) || _.isUndefined(day.modelLimit) || _.isNull(day.modelLimit)) {
        day.modelLimit = 0;
      }

      if (day.modelLimit > 0) {
        day.modelLimit = day.modelLimit - 1;
      }
    };

    vm.incrementLimit = function(day) {
      if (day.modelLimit === '' || _.isNaN(day.modelLimit) || _.isUndefined(day.modelLimit) || _.isNull(day.modelLimit)) {
        day.modelLimit = 0;
      }

      day.modelLimit = day.modelLimit + 1;
    };

    vm.openExceptionCreateModal = function(optionalDayOffLimitRecord) {
      var modalInstance = $uibModal.open({
        size: 'day-off-limit-exception',
        templateUrl: 'views/daysOff/dayOffLimitExceptionModal.html',
        controller: 'CreateDayOffLimitExceptionModalCtrl',
        controllerAs: 'vm',
        resolve: {
          params: function() {
            return {
              me: vm.me,
              org: vm.org,
              dayOffLimitRecord: optionalDayOffLimitRecord
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed dayOffLimitExceptionModal');
          console.log(result);

          reloadDayOffLimits();
        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);

        });
    };

    vm.removeLimit = function(dayOffLimit) {
      // Are you sure you want to remove this day off exception? The limit for this day will revert back to general Friday limit of 21.

      var text = 'Are you sure you want to remove this day off exception?';

      var generalLimitForDay;
      DayOffLimitStore.getGeneralLimitForDate(dayOffLimit.target_date)
        .then(function(limitRecord) {
          console.log('resulting...', limitRecord);
          if (limitRecord) {
            generalLimitForDay = limitRecord;
          }

          if (generalLimitForDay) {
            text += ' The limit for this day will revert back to the general ' + dayOffLimit.target_date.format('dddd') + ' limit of ' + generalLimitForDay.limit + '.';
          } else {
            text += 'There is no general limit for ' + dayOffLimit.target_date.format('dddd') + ' right now, so ' + dayOffLimit.target_date.format('MMM D, YYYY') + ' will not have a limit.';
          }

          $confirm({
            title: 'Remove Day Off Exception?',
            text: text,
            ok: 'Yes, remove it',
            cancel: 'No, don\'t remove it'
          })
            .then(function() {
              dayOffLimit.$remove()
                .then(function() {
                  DayOffLimitStore.removeRecordById(dayOffLimit.id);
                  reloadDayOffLimits();
                }, function() {

                })
            }, function() {

            });
        }, function() {

        });
    };

    vm.editLimit = function(dayOffLimit) {
      vm.openExceptionCreateModal(dayOffLimit);
    };

    initDayOffLimitDerivations();
    setupWeekToModify();

  });
